import React from 'react';
import classnames from 'classnames';
import { Translate, withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { Formik, Form } from 'formik';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Circles } from '../common/loadingComponent';
import { popupActions } from '../../store/popupStore';
import { domainActions } from '../../store/domainStore';
import { layoutActions } from '../../store/layoutStore';
import { monitoringActions } from '../../store/monitoringStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { apiPost, getHostApi } from '../../store/apiWrapper';
import Message from '../common/message';
import Subjects from './createSection/porfolioSubjectsSection';
import Relations from './createSection/relationSection';
import ColumnWrap from '../marketingList/columnWrap';
import Identification from './createSection/identificactionSection';
import NoDataComponent from '../common/noDataComponent';
import MonitoringSettingsSection from './createSection/monitoringSettingsSection';
import { writeErr } from '../common/logger';
import { PORTFOLIO_TYPES } from './monitoringConstants';

import './monitoring.scss';

const MODE = {
    create: "CREATE",
    edit: "EDIT"
}

const SECTION = {
    identification: "IDENTIFICATION",
    settings: "SETTINGS"
};

const DEFAULT_CONFIG = {
    identification: {
        name: "",
        type: "",
        portfolioType: null,
        marketingCountry: null,
        inactiveOwner: false
    },
    relationTypes: {
        all: [],
        parent: [],
        allSelected: false
    },
    monitoringSettings: {
        active: true,
        enabledNotifications: false,
        notificationReceivers: [''],
        ownerEmail: "",
        events: {
            all: [],
            parent: [],
            allSelected: false
        }
    },
    portfolioSubjects: [],
    sharingRole: 100,
    isA2A: false
};

class NewPorfolio extends React.Component {
    mounted = false;
    hasData = false;

    state = {
        config: DEFAULT_CONFIG,
        isSubmitting: false,
        portfolioType: "",
        marketingCountry: "",
        mode: null,
        id: null,
        error: false,
        isLoading: false,
        subjectsCount: 0,
        isFirstLevel: false,
        subjectMessageType: null,
        subjectMessageText: null,
        identMessageType: null,
        identMessageText: null
    };

    render() {
        if (this.state.isLoading)
            return <Circles/>;
        if (!this.props.portfolioDomainsLoaded)
            return <NoDataComponent />;
        return this.renderForm();
    }

    componentDidMount() {
        this.setState({ mode: this.props.match.params.id !== undefined ? MODE.edit : MODE.create });
        this.props.match.params.id !== undefined && this.setState({ id: this.props.match.params.id });
        this.props.ensureDomainData("monitored-events-dictionary");
        this.props.ensureDomainData("monitored-list-types");
        this.props.ensureDomainData("sources");
        this.mounted = true;
    }

    componentDidUpdate() {
        if (this.props.match.params.id !== undefined && this.props.portfolioDomainsLoaded && !this.state.isLoading && !this.hasData)
            this.getPortfolio();
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    renderForm = () => {
        return (
            <div>
                {!isNullOrUndefined(this.state.error) && !isNullOrUndefined(this.state.error.exception) && <Message type="error" style={{ marginTop: "1em" }}
                    message={this.props.translate(this.state.error.exception, this.state.error.exceptionData)} options={{ renderInnerHtml: true }}
                />}
                <Formik
                    ref={(el) => this.formRef = el}
                    enableReinitialize={true}
                    initialValues={{ ...this.state.config }}
                    onSubmit={() => {}}
                >
                    {({ values }) => <Form onKeyDown={this.onKeyDown} noValidate>
                        <div className="columns is-multiline is-centered">
                            <div className="column">
                                <ColumnWrap style={{ paddingTop: "2em" }}>
                                    <Identification disabled={
                                        this.state.mode === MODE.edit} type={this.state.config.identification.type}
                                        marketingCountry={this.state.config.identification.marketingCountry} isOpen={true} mode={this.state.mode}
                                        onSubmit={() => this.submitForm(values, SECTION.identification)}
                                        subjects={this.state.config.portfolioSubjects}
                                        hasAllFirstLevelPortfolios={this.state.config.hasAllFirstLevelPortfolios}
                                        identMessageText={this.state.identMessageText}
                                        identMessageType={this.state.identMessageType}
                                        changeIdentMessage={(type, text) => this.setState({ identMessageText: text, identMessageType: type })}
                                        onTypeChanged={() => this.onTypeChanged(values)}
                                        isFirstLevel={this.state.isFirstLevel}
                                        sharingRole={this.state.config.sharingRole}
                                        inactiveOwner={this.state.config.identification.inactiveOwner}
                                        isA2A={this.state.config.isA2A}
                                    />
                                </ColumnWrap>
                                {this.state.mode === MODE.edit && this.renderMonitoringSettings(values)}
                            </div>
                        </div>
                    </Form>}
                </Formik>
            </div>
        )
    }

    onKeyDown(keyEvent) {
        if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
          keyEvent.preventDefault();
        }
      }

    renderMonitoringSettings = (values) => {
        if (values.identification.name === "" || values.identification.type === "")
            return null;

        if (this.mounted && this.state.isLoading)
            return <Circles />

        return (
            <>
                {this.state.isFirstLevel === true && this.state.config.identification.portfolioType !== PORTFOLIO_TYPES.cadastreSk && <ColumnWrap>
                    <Relations isOpen={true} />
                </ColumnWrap>}
                <ColumnWrap>
                    <MonitoringSettingsSection isOpen={true}
                        type={this.state.config.identification.portfolioType}
                        isFirstLevel={this.state.isFirstLevel}
                        onSubmit={() => this.submitForm(values, SECTION.settings)}
                        identMessageType={this.state.identMessageType}
                        identMessageText={this.state.identMessageText}
                        sharingRole={this.state.config.sharingRole}
                    />
                </ColumnWrap>
                {/* subjects are bound only after refresh, component will handle paging on its own */}
                <ColumnWrap>
                    <Subjects
                        refresh={() => this.getPortfolio()}
                        subjects={this.state.config.portfolioSubjects}
                        subjectsCount={this.state.subjectsCount}
                        subjectsExportExcelMax={this.state.subjectsExportExcelMax}
                        subjectsExportCsvMax={this.state.subjectsExportCsvMax}
                        pt={this.state.config.identification.portfolioType}
                        hasAllFirstLevelPortfolios={this.state.config.hasAllFirstLevelPortfolios}
                        isFirstLevel={this.state.isFirstLevel}
                        isOpen={true}
                        subjectMessageText={this.state.subjectMessageText}
                        subjectMessageType={this.state.subjectMessageType}
                        changeMessage={(type, text) => this.setState({ subjectMessageText: text, subjectMessageType: type })}
                        sharingRole={this.state.config.sharingRole}
                    />
                </ColumnWrap>
            </>
        )
    }

    onTypeChanged(v) {
        if (!isNullOrUndefined(v) && this.state.portfolioType !== v)
            this.setState({ portfolioType: v });
    }

    getPortfolio() {
        this.setState({ isLoading: true });
        let filter = { "page": "1", "count": "20" };
        apiPost(`${getHostApi()}/api/portfolio/${this.props.match.params.id}`, null, filter,
            (r) => {
                this.hasData = true;
                if (r.data.isSuccess) {
                    this.setState({
                        config: {
                            ...this.state.config,
                            identification: {
                                name: r.data.name,
                                //string
                                type: r.data.type.replace("<br />", " - "),
                                //int
                                portfolioType: r.data.portfolioType,
                                marketingCountry: r.data.marketingCountry,
                                inactiveOwner: r.data.isUserInactive
                            },
                            portfolioSubjects: r.data.companies || r.data.persons || r.data.documents,
                            monitoringSettings: {
                                ...this.state.config.monitoringSettings,
                                active: r.data.isMonitored,
                                events: this.loadMulti(r.data.events, this.props['monitored-events-dictionary']),
                                notificationReceivers: r.data.emails,
                                ownerEmail: r.data.ownerEmail,
                                emptyNotifications: r.data.emptyNotifications,
                                enabledNotifications: r.data.enabledNotification
                            },
                            hasAllFirstLevelPortfolios: r.data.hasAllFirstLevelPortfolios,
                            relationTypes: { all: r.data.relations },
                            sharingRole: r.data.sharing.filter((f) => f.userId === this.props.user.authentication.profile.id)[0].role,
                            isA2A: r.data.isA2A
                        },
                        error: null,
                        isLoading: false,
                        subjectsCount: r.data.totalRows || r.data.subjects,
                        isFirstLevel: r.data.parentId !== null,
                        subjectsExportExcelMax: r.data.subjectsExportExcelMax,
                        subjectsExportCsvMax: r.data.subjectsExportCsvMax,
                    });
                } else
                    this.setState({ isLoading: false, error: { exception: r.data.exception, exceptionData: this.getExceptionData(r.data.exceptionData) } });
            },
            (e) => writeErr(e)
        );
    }

    submitForm(values, section) {
        this.state.mode === MODE.create ? this.createPortfolio(values) : this.submitEdit(values, section)
    }

    submitEdit(values, section) {
        this.setState({ isSubmitting: true });
        if (!isNullOrUndefined(this.state.id)) {
            apiPost(
                `${getHostApi()}/api/portfolio/${this.state.id}/update`,
                {},
                this.transformForPost(values, section),
                (s) => this.submitDone(s.data),
                (e) => {
                    this.setState({ identMessageType: 'error',identMessageText: this.props.translate(e.data.error.message || "Common.Error") });
                    writeErr(e);
                }
            );
        }
    }

    submitDone(result) {
        this.setState({ isSubmitting: false });
        if (!result.isSuccess)
            this.setState({ hideForm: true, error: { exception: result.exception, exceptionData: this.getExceptionData(result.exceptionData) } });
        else
            this.setState({ identMessageType: 'success', identMessageText: this.props.translate("Portfolio.Search.PortfolioUpdated") });
    }

    transformForPost(values, section) {
        let v = JSON.parse(JSON.stringify(values));

        var data = {
            name: null,
            portfolioType: null,
            emails: null,
            isMonitored: null,
            events: null,
            relations: null
        };

        if (section === SECTION.identification)
            data.name = v.identification.name;
        else if (section === SECTION.settings) {
            data.emails = v.monitoringSettings.notificationReceivers;
            data.isMonitored = v.monitoringSettings.active;
            data.events = [...v.monitoringSettings.events.all.map(x => x.value)];
            data.relations = [...v.relationTypes.all.map(x => x.value)];
            data.emptyNotifications = v.monitoringSettings.emptyNotifications;
            data.enabledNotifications = v.monitoringSettings.enabledNotifications;
        }

        return JSON.parse(JSON.stringify(data));
    }

    createPortfolio(values) {
        this.setState({ isLoading: true });
        this.props.createEmptyPortfolio(values.identification.name, values.identification.type,
            (r) => {
                if (r.data.isSuccess){
                    this.setState({ mode: MODE.edit, isLoading: false, id: r.data.id, identMessageText: undefined, identMessageType: undefined });
                    this.props.history.push(`/monitoring/editPortfolio/${r.data.id}`);
                }
                else
                    this.setState({ isLoading: false, id: null, error: { exception: r.data.exception, exceptionData: this.getExceptionData(r.data.exceptionData) } });
            }
        );
    }

    getMonitoredListTypes = () => {
        if (this.props.sources.isRequesting || this.props.sources.requestResult === null)
            return [];
        else {
            let result = [];
            this.props.sources.requestResult.map((s => { result.push({ value: s.value, label: s.label, shortening: s.shortening }) }));
            return result;
        }
    }

    sharePortfolio = () => {
        this.props.showPopup("sharePortfolio", {
            portfolioId: this.state.id,
            open: true,
            ok: () => { },
            close: () => { this.props.hidePopup(); }
        })
    }

    loadMulti = (obj, domain) => {
        if (isNullOrUndefined(obj) || isNullOrUndefined(domain.requestResult) || domain.requestResult.length === 0)
            return undefined;

        const result = {};
        if (obj.allSelected)
            obj.all = domain.requestResult.map(x => x.value);

        const all = obj.all.slice(0).map(i => this.findInTree(i, domain.requestResult));
        let selection = all.filter(f => !isNullOrUndefined(f) && !isNullOrUndefined(f.value));
        result.all = selection
        result.parent = [];
        result.allSelected = obj.allSelected;
        return result;
    }

    findInTree(value, tree) {
        if (isNullOrUndefined(value) || isNullOrUndefined(tree))
            return null;
        let node = [];
        tree.forEach((e) => node = node.concat(e.children.filter((c) => c.value == value)));
        if (!isNullOrUndefined(node) && node.children !== undefined)
            node.children = undefined;
        return node[0];
    }

    getExceptionData = (e) => isNullOrUndefined(e) ? undefined : e;
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.domain, user: state.userContext }),
    dispatch => bindActionCreators(Object.assign({}, domainActions, monitoringActions, layoutActions, popupActions), dispatch),
)(NewPorfolio)));